
export const COLORS = {
    backgroundColor: "#121b1c",
    secondaryBackgroundColor: "#122525",
    thirdBackgroundColor: "#0f2222",
    textColor: "#7a8079",
    primaryAccent: "#23726f",
    secondaryAccent: "#254e4d",
    firstCounter: "#4C0827",
    secondCounter: "#620d66",
}